import type { BondStatus, PersonStatus } from '../api';
import { BOND_STATUS_LABELS, PERSON_STATUS_LABELS, StatusTone, bondStatusTone } from './format';

const TONES: Record<StatusTone, string> = {
  green: 'bg-green-100 text-green-800',
  blue: 'bg-blue-100 text-blue-800',
  amber: 'bg-amber-100 text-amber-800',
  gray: 'bg-gray-100 text-gray-600',
  red: 'bg-red-100 text-red-700',
};

function Badge({ tone, children }: { tone: StatusTone; children: string }) {
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${TONES[tone]}`}>{children}</span>
  );
}

export function BondStatusBadge({ status }: { status: BondStatus }) {
  return <Badge tone={bondStatusTone(status)}>{BOND_STATUS_LABELS[status] ?? status}</Badge>;
}

export function PersonStatusBadge({ status }: { status: PersonStatus }) {
  const tone: StatusTone = status === 'validada' ? 'green' : status === 'em_validacao' || status === 'pre_cadastrada' ? 'amber' : 'gray';
  return <Badge tone={tone}>{PERSON_STATUS_LABELS[status] ?? status}</Badge>;
}
